import { pageSizes, pickerOptions } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize';
import HisAutocompleteSuggestions from '@/components/HisAutocompleteSuggestions/index.vue';
import FooterControl from '@/components/FooterControl.vue';

export default {
  name: 'wait-fee',
  mixins: [pageSize],
  components: { HisAutocompleteSuggestions, FooterControl },
  data() {
    return {
      pageSizes,
      tableData: [],
      total: 0, // 总数据条数
      query: {
        startTime: '',
        endTime: '',
        pageSize: 20, // 每页数据条数
        currentPage: 1, // 页码 从1开始
      },
      time: [],
      pickerOptions,
    };
  },
  methods: {
    // 获取列表信息
    getTableData(type) {
      if (type === 1) this.query.currentPage = 1;
      this.query.startTime = this.time ? this.time[0] : '';
      this.query.endTime = this.time ? this.time[1] : '';
      this.$api.systemSet.registedHospital(this.query).then((res) => {
        console.log(res);
        this.tableData = res.hospitalList || [];
        this.total = res.totalSize;
      });
    },
    // 每页展示数据条数变更
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getTableData(1);
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.currentPage = val;
      this.getTableData();
    },
    // 跳转注册诊所
    gotoEditHospital(id) {
      this.$router.push({ path: '/system/newClinic', query: { state: 'registe', id } });
    },
    // 更新备注
    updateRemark(remark, id) {
      this.$api.systemSet.updateRegistedHospital({
        remark,
        id,
      }).then((res) => {
        console.log(res);
      });
    },
    // 导出
    fileExport() {
      if (this.tableData.length < 1) {
        this.$alert('没有诊所申请信息，请更换查询条件试试', '提示', {
          confirmButtonText: '确定',
        }).catch(() => {
        });
      } else {
        this.query.startTime = this.time ? this.time[0] : '';
        this.query.endTime = this.time ? this.time[1] : '';
        this.$api.systemSet.registedHospitalExport({
          startTime: this.query.startTime,
          endTime: this.query.endTime,
        });
      }
    },
  },
  mounted() {
    this.getTableData();
  },
};
